import { utils } from '@seedplanner/shared-utils';
import dayjs from 'dayjs';
import timezonePlugin from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

export const checkGrowTimeAndDeliveryDate = ({
  cropTotalGrowTime,
  deliveryDate,
  bufferTime,
  userTimezone,
}: {
  readonly cropTotalGrowTime: number;
  readonly deliveryDate: dayjs.Dayjs;
  readonly bufferTime: number;
  readonly userTimezone: string;
}): { readonly startDate: dayjs.Dayjs; readonly canBeStartedInTime: boolean; readonly harvestDate: dayjs.Dayjs } => {
  const startDate = dayjs.unix(deliveryDate.unix() - cropTotalGrowTime - bufferTime).tz(userTimezone);
  const todayStart = utils.todayStart(userTimezone);
  const canBeStartedInTime = startDate.isSame(todayStart, 'day') || startDate.isAfter(todayStart, 'day');
  const harvestDate = deliveryDate.subtract(bufferTime, 'seconds');

  return {
    startDate,
    harvestDate,
    canBeStartedInTime,
  };
};
